module.exports = __webpack_public_path__ + "img/benefit-silver-member.9b3404e7.png";